//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '5.2.0'.
//
package blazern.lexisoup.graphql.model.adapter

import blazern.lexisoup.graphql.model.LexicalItemsFromLLMQuery
import blazern.lexisoup.graphql.model.fragment.TranslationsSetFieldsImpl_ResponseAdapter
import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.StringAdapter
import com.apollographql.apollo.api.evaluate
import com.apollographql.apollo.api.json.JsonReader
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.list
import com.apollographql.apollo.api.missingField
import com.apollographql.apollo.api.obj
import com.apollographql.apollo.api.possibleTypes
import kotlin.String
import kotlin.collections.List

public object LexicalItemsFromLLMQuery_ResponseAdapter {
  public object Data : Adapter<LexicalItemsFromLLMQuery.Data> {
    public val RESPONSE_NAMES: List<String> = listOf("llm")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): LexicalItemsFromLLMQuery.Data {
      var _llm: List<LexicalItemsFromLLMQuery.Llm>? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _llm = Llm.obj(true).list().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return LexicalItemsFromLLMQuery.Data(
        llm = _llm ?: missingField(reader, "llm")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: LexicalItemsFromLLMQuery.Data,
    ) {
      writer.name("llm")
      Llm.obj(true).list().toJson(writer, customScalarAdapters, value.llm)
    }
  }

  public object Llm : Adapter<LexicalItemsFromLLMQuery.Llm> {
    public val RESPONSE_NAMES: List<String> = listOf("__typename")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): LexicalItemsFromLLMQuery.Llm {
      var __typename: String? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> __typename = StringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      check(__typename != null) {
        "__typename was not found"
      }

      var _onForms: LexicalItemsFromLLMQuery.OnForms? = null
      if (possibleTypes("Forms").evaluate(customScalarAdapters.falseVariables, __typename, customScalarAdapters.deferredFragmentIdentifiers, null)) {
        reader.rewind()
        _onForms = blazern.lexisoup.graphql.model.adapter.LexicalItemsFromLLMQuery_ResponseAdapter.OnForms.fromJson(reader, customScalarAdapters)
      }

      var _onExplanation: LexicalItemsFromLLMQuery.OnExplanation? = null
      if (possibleTypes("Explanation").evaluate(customScalarAdapters.falseVariables, __typename, customScalarAdapters.deferredFragmentIdentifiers, null)) {
        reader.rewind()
        _onExplanation = blazern.lexisoup.graphql.model.adapter.LexicalItemsFromLLMQuery_ResponseAdapter.OnExplanation.fromJson(reader, customScalarAdapters)
      }

      var _onWordTranslations: LexicalItemsFromLLMQuery.OnWordTranslations? = null
      if (possibleTypes("WordTranslations").evaluate(customScalarAdapters.falseVariables, __typename, customScalarAdapters.deferredFragmentIdentifiers, null)) {
        reader.rewind()
        _onWordTranslations = blazern.lexisoup.graphql.model.adapter.LexicalItemsFromLLMQuery_ResponseAdapter.OnWordTranslations.fromJson(reader, customScalarAdapters)
      }

      var _onSynonyms: LexicalItemsFromLLMQuery.OnSynonyms? = null
      if (possibleTypes("Synonyms").evaluate(customScalarAdapters.falseVariables, __typename, customScalarAdapters.deferredFragmentIdentifiers, null)) {
        reader.rewind()
        _onSynonyms = blazern.lexisoup.graphql.model.adapter.LexicalItemsFromLLMQuery_ResponseAdapter.OnSynonyms.fromJson(reader, customScalarAdapters)
      }

      var _onExample: LexicalItemsFromLLMQuery.OnExample? = null
      if (possibleTypes("Example").evaluate(customScalarAdapters.falseVariables, __typename, customScalarAdapters.deferredFragmentIdentifiers, null)) {
        reader.rewind()
        _onExample = blazern.lexisoup.graphql.model.adapter.LexicalItemsFromLLMQuery_ResponseAdapter.OnExample.fromJson(reader, customScalarAdapters)
      }

      return LexicalItemsFromLLMQuery.Llm(
        __typename = __typename,
        onForms = _onForms,
        onExplanation = _onExplanation,
        onWordTranslations = _onWordTranslations,
        onSynonyms = _onSynonyms,
        onExample = _onExample
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: LexicalItemsFromLLMQuery.Llm,
    ) {
      writer.name("__typename")
      StringAdapter.toJson(writer, customScalarAdapters, value.__typename)

      if (value.onForms != null) {
        OnForms.toJson(writer, customScalarAdapters, value.onForms)
      }

      if (value.onExplanation != null) {
        OnExplanation.toJson(writer, customScalarAdapters, value.onExplanation)
      }

      if (value.onWordTranslations != null) {
        OnWordTranslations.toJson(writer, customScalarAdapters, value.onWordTranslations)
      }

      if (value.onSynonyms != null) {
        OnSynonyms.toJson(writer, customScalarAdapters, value.onSynonyms)
      }

      if (value.onExample != null) {
        OnExample.toJson(writer, customScalarAdapters, value.onExample)
      }
    }
  }

  public object OnForms : Adapter<LexicalItemsFromLLMQuery.OnForms> {
    public val RESPONSE_NAMES: List<String> = listOf("text", "source")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): LexicalItemsFromLLMQuery.OnForms {
      var _text: String? = null
      var _source: String? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _text = StringAdapter.fromJson(reader, customScalarAdapters)
          1 -> _source = StringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return LexicalItemsFromLLMQuery.OnForms(
        text = _text ?: missingField(reader, "text"),
        source = _source ?: missingField(reader, "source")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: LexicalItemsFromLLMQuery.OnForms,
    ) {
      writer.name("text")
      StringAdapter.toJson(writer, customScalarAdapters, value.text)

      writer.name("source")
      StringAdapter.toJson(writer, customScalarAdapters, value.source)
    }
  }

  public object OnExplanation : Adapter<LexicalItemsFromLLMQuery.OnExplanation> {
    public val RESPONSE_NAMES: List<String> = listOf("text", "source")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): LexicalItemsFromLLMQuery.OnExplanation {
      var _text: String? = null
      var _source: String? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _text = StringAdapter.fromJson(reader, customScalarAdapters)
          1 -> _source = StringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return LexicalItemsFromLLMQuery.OnExplanation(
        text = _text ?: missingField(reader, "text"),
        source = _source ?: missingField(reader, "source")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: LexicalItemsFromLLMQuery.OnExplanation,
    ) {
      writer.name("text")
      StringAdapter.toJson(writer, customScalarAdapters, value.text)

      writer.name("source")
      StringAdapter.toJson(writer, customScalarAdapters, value.source)
    }
  }

  public object OnWordTranslations : Adapter<LexicalItemsFromLLMQuery.OnWordTranslations> {
    public val RESPONSE_NAMES: List<String> = listOf("source", "translationsSet")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): LexicalItemsFromLLMQuery.OnWordTranslations {
      var _source: String? = null
      var _translationsSet: LexicalItemsFromLLMQuery.TranslationsSet? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _source = StringAdapter.fromJson(reader, customScalarAdapters)
          1 -> _translationsSet = TranslationsSet.obj(true).fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return LexicalItemsFromLLMQuery.OnWordTranslations(
        source = _source ?: missingField(reader, "source"),
        translationsSet = _translationsSet ?: missingField(reader, "translationsSet")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: LexicalItemsFromLLMQuery.OnWordTranslations,
    ) {
      writer.name("source")
      StringAdapter.toJson(writer, customScalarAdapters, value.source)

      writer.name("translationsSet")
      TranslationsSet.obj(true).toJson(writer, customScalarAdapters, value.translationsSet)
    }
  }

  public object TranslationsSet : Adapter<LexicalItemsFromLLMQuery.TranslationsSet> {
    public val RESPONSE_NAMES: List<String> = listOf("__typename")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): LexicalItemsFromLLMQuery.TranslationsSet {
      var __typename: String? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> __typename = StringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      reader.rewind()
      val _translationsSetFields = blazern.lexisoup.graphql.model.fragment.TranslationsSetFieldsImpl_ResponseAdapter.TranslationsSetFields.fromJson(reader, customScalarAdapters)

      return LexicalItemsFromLLMQuery.TranslationsSet(
        __typename = __typename ?: missingField(reader, "__typename"),
        translationsSetFields = _translationsSetFields
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: LexicalItemsFromLLMQuery.TranslationsSet,
    ) {
      writer.name("__typename")
      StringAdapter.toJson(writer, customScalarAdapters, value.__typename)

      TranslationsSetFieldsImpl_ResponseAdapter.TranslationsSetFields.toJson(writer, customScalarAdapters, value.translationsSetFields)
    }
  }

  public object OnSynonyms : Adapter<LexicalItemsFromLLMQuery.OnSynonyms> {
    public val RESPONSE_NAMES: List<String> = listOf("source", "translationsSet")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): LexicalItemsFromLLMQuery.OnSynonyms {
      var _source: String? = null
      var _translationsSet: LexicalItemsFromLLMQuery.TranslationsSet1? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _source = StringAdapter.fromJson(reader, customScalarAdapters)
          1 -> _translationsSet = TranslationsSet1.obj(true).fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return LexicalItemsFromLLMQuery.OnSynonyms(
        source = _source ?: missingField(reader, "source"),
        translationsSet = _translationsSet ?: missingField(reader, "translationsSet")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: LexicalItemsFromLLMQuery.OnSynonyms,
    ) {
      writer.name("source")
      StringAdapter.toJson(writer, customScalarAdapters, value.source)

      writer.name("translationsSet")
      TranslationsSet1.obj(true).toJson(writer, customScalarAdapters, value.translationsSet)
    }
  }

  public object TranslationsSet1 : Adapter<LexicalItemsFromLLMQuery.TranslationsSet1> {
    public val RESPONSE_NAMES: List<String> = listOf("__typename")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): LexicalItemsFromLLMQuery.TranslationsSet1 {
      var __typename: String? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> __typename = StringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      reader.rewind()
      val _translationsSetFields = blazern.lexisoup.graphql.model.fragment.TranslationsSetFieldsImpl_ResponseAdapter.TranslationsSetFields.fromJson(reader, customScalarAdapters)

      return LexicalItemsFromLLMQuery.TranslationsSet1(
        __typename = __typename ?: missingField(reader, "__typename"),
        translationsSetFields = _translationsSetFields
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: LexicalItemsFromLLMQuery.TranslationsSet1,
    ) {
      writer.name("__typename")
      StringAdapter.toJson(writer, customScalarAdapters, value.__typename)

      TranslationsSetFieldsImpl_ResponseAdapter.TranslationsSetFields.toJson(writer, customScalarAdapters, value.translationsSetFields)
    }
  }

  public object OnExample : Adapter<LexicalItemsFromLLMQuery.OnExample> {
    public val RESPONSE_NAMES: List<String> = listOf("source", "translationsSet")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): LexicalItemsFromLLMQuery.OnExample {
      var _source: String? = null
      var _translationsSet: LexicalItemsFromLLMQuery.TranslationsSet2? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _source = StringAdapter.fromJson(reader, customScalarAdapters)
          1 -> _translationsSet = TranslationsSet2.obj(true).fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return LexicalItemsFromLLMQuery.OnExample(
        source = _source ?: missingField(reader, "source"),
        translationsSet = _translationsSet ?: missingField(reader, "translationsSet")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: LexicalItemsFromLLMQuery.OnExample,
    ) {
      writer.name("source")
      StringAdapter.toJson(writer, customScalarAdapters, value.source)

      writer.name("translationsSet")
      TranslationsSet2.obj(true).toJson(writer, customScalarAdapters, value.translationsSet)
    }
  }

  public object TranslationsSet2 : Adapter<LexicalItemsFromLLMQuery.TranslationsSet2> {
    public val RESPONSE_NAMES: List<String> = listOf("__typename")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): LexicalItemsFromLLMQuery.TranslationsSet2 {
      var __typename: String? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> __typename = StringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      reader.rewind()
      val _translationsSetFields = blazern.lexisoup.graphql.model.fragment.TranslationsSetFieldsImpl_ResponseAdapter.TranslationsSetFields.fromJson(reader, customScalarAdapters)

      return LexicalItemsFromLLMQuery.TranslationsSet2(
        __typename = __typename ?: missingField(reader, "__typename"),
        translationsSetFields = _translationsSetFields
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: LexicalItemsFromLLMQuery.TranslationsSet2,
    ) {
      writer.name("__typename")
      StringAdapter.toJson(writer, customScalarAdapters, value.__typename)

      TranslationsSetFieldsImpl_ResponseAdapter.TranslationsSetFields.toJson(writer, customScalarAdapters, value.translationsSetFields)
    }
  }
}
